import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { GetMunicipiosRepository } from '@data/repository/home/getMunicipios.repository';
import { GetPaisesRepository } from '@data/repository/home/getPaises.repository';
import { GetTiposEnderecoRepository } from '@data/repository/home/getTiposEndereco.repository';
import { Cliente } from '@domain/dto/cliente/cliente-get.dto';
import { ServicoAdicional, Taxa } from '@domain/dto/vehicle/vehicle-get.dto';
import { environment } from '@environment/environment';
import { ReservaService } from '@infra/reserva/reserva.service';
import { TranslateService } from '@ngx-translate/core';
import { PersonController } from '@presentation/controllers/person/person.controller';
import { ReservaController } from '@presentation/controllers/reserva/reserva.controller';
import { DialogTermsComponent } from '@presentation/view/shared/dialogs/dialog-terms/dialog-terms.component';
import {
  NotificationService,
  NotificationStyle,
} from '@presentation/view/shared/notification/notification.service';
import Compressor from 'compressorjs';
import * as moment from 'moment';
import { Observable, finalize, map, startWith } from 'rxjs';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.scss'],
})
export class PersonComponent implements OnInit {
  formReservasPost: FormGroup;
  formReservas: FormGroup;
  isLoading: boolean = false;
  isCPF: boolean = true;
  isPassaport: boolean = false;
  isItin: boolean = false
  codigoCliente: number | null = null;
  dateSelected: Date | null;
  dateExpireDriveLicense: Date | null;
  acceptedTerms: any = null;
  minBirthDate: Date;
  maxBirthDate: Date;
  urlControleLocacao = sessionStorage.getItem('urlContratoLocacao');
  cliente: Cliente;
  lastPassaporte: string;
  lastRg: string;
  lastCPF: string;
  isRequest: any;
  english: boolean = false;
  phoneMask: string;
  currentLanguage: string;
  pagamentoStripe = 'N'
  summaryInvisible: boolean = true;
  isMobile: boolean = false;
  personData: any;
  extraHours: any;
  solicitarDocumentos: any;
  selectedDocument: string;
  isDriveLicense: boolean = false;
  anexosPayload: any = {}
  habilitarRedirecionamentoIMOB: boolean = false;
  exibirAgrupamentoEndereco: boolean = false;
  filteredPaises!: Observable<any>;
  filteredMunicipios!: Observable<any>;
  filteredTiposEndereco!: Observable<any>;
  myControlPais = new FormControl('');
  myControlMunicipio = new FormControl('');
  myControlTipoEndereco = new FormControl('');
  paises = [];
  municipios = [];
  tiposEndereco = [];
  novoCliente: boolean = false;
  desobrigarIdentificadorPessoa: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    if (window.innerWidth <= 960) this.isMobile = true;
    else this.isMobile = false;
  }

  constructor(
    private _formBuilder: FormBuilder,
    private dialog: MatDialog,
    public reservaService: ReservaService,
    private notification: NotificationService,
    private controller: PersonController,
    public translateService: TranslateService,
    public getPaisesRepository: GetPaisesRepository,
    private controllerReserva: ReservaController,
    public getMunicipiosRepository: GetMunicipiosRepository,
    public getTiposEnderecoRepository: GetTiposEnderecoRepository,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) {
    this.minBirthDate = new Date();
    this.minBirthDate.setFullYear(this.minBirthDate.getFullYear() - 100);
    this.maxBirthDate = new Date();
    this.maxBirthDate.setFullYear(this.maxBirthDate.getFullYear() - 18);
    this.phoneMask = localStorage.getItem('language') == 'en-US' ? '(000) 000-0000' : '(00) 00000-0000';
    this.currentLanguage = localStorage.getItem('language')
    this.pagamentoStripe = sessionStorage.getItem('pagamentoStripe')
    this.solicitarDocumentos = JSON.parse(sessionStorage.getItem('solicitarDocumentos'));
    this.habilitarRedirecionamentoIMOB = sessionStorage.getItem('habilitarRedirecionamentoIMOB') == 'S'
    this.desobrigarIdentificadorPessoa = sessionStorage.getItem('desobrigarIdentificadorPessoa') == 'S'

  }

  async ngOnInit(): Promise<void> {
    this.createFormGroup();
    await this.getPaises();
    await this.getMunicipios();
    await this.getTiposEndereco();
    this.isRequest = sessionStorage.getItem('modoUtilizacao');
    this.english = localStorage.getItem('language') === 'en-US';

    this.checkScreenSize();

    this.extraHours = JSON.parse(sessionStorage.getItem('extraHours'))

    if (this.solicitarDocumentos.SolicitarSSN == 'S') {
      this.selectedDocument = 'cpf'; // Isso marcará o radio "cpf"
      this.onDocumentChange('cpf')
    } else if (this.solicitarDocumentos.SolicitarITIN == 'S') {
      this.selectedDocument = 'rg'; // Isso marcará o radio "rg"
      this.onDocumentChange('rg')
    } else if (this.solicitarDocumentos.SolicitarPassaport == 'S') {
      this.selectedDocument = 'passaporte'; // Isso marcará o radio "passaporte"
      this.onDocumentChange('passaporte')
    }
    else if (this.solicitarDocumentos.SolicitarDriveLicense == 'S') {
      this.selectedDocument = 'drivelicense'; // Isso marcará o radio "drivelicense"
      this.onDocumentChange('drivelicense')
    }

    if (this.habilitarRedirecionamentoIMOB && this.desobrigarIdentificadorPessoa) {
      this.formReservas.get('cpf').clearValidators();
      this.formReservas.get('cpf').updateValueAndValidity();
    }

    const data = sessionStorage.getItem('personData');
    if (data) {
      const parsedData = JSON.parse(data);
      this.dateSelected = this.parseStringToDate(parsedData.dataNascimento);
      this.formReservas.patchValue(parsedData);

      if (this.formReservas.get('cpf').value) {
        this.selectedDocument = 'cpf'
        this.onDocumentChangeOnLoad('cpf')
        this.getClienteCPF(this.formReservas.get('cpf').value)
      }
      if (this.formReservas.get('rg').value) {
        this.selectedDocument = 'rg'
        this.onDocumentChangeOnLoad('rg')
        this.getClienteRG(this.formReservas.get('rg').value)
      }
      if (this.formReservas.get('passaporte').value) {
        this.selectedDocument = 'passaporte'
        this.onDocumentChangeOnLoad('passaporte')
        this.getClientePassaporte(this.formReservas.get('passaporte').value)
      }
      if (this.formReservas.get('driveLicenseNumber').value) {
        this.selectedDocument = 'drivelicense'
        this.onDocumentChangeOnLoad('drivelicense')
        this.getClienteCNH(this.formReservas.get('driveLicenseNumber').value)
      }
    }


  }

  parseStringToDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    if (environment.defaultDateInput === 'MM/DD/YYYY') {
      const [month, day, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    } else {
      const [day, month, year] = dateStr.split('/').map(Number);
      return new Date(year, month - 1, day);
    }
  }
  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768; // Define como mobile se a largura for menor ou igual a 768px
  }

  buildMatAutoCompletePaises() {
    this.filteredPaises = this.formReservas.get('codigoPais').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterPaises(value || ''))
    );
  }

  buildMatAutoCompleteMunicipios() {
    this.filteredMunicipios = this.formReservas.get('codigoMunicipio').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterMunicipios(value || ''))
    );
  }


  buildMatAutoCompleteTipoEndereco() {
    this.filteredTiposEndereco = this.formReservas.get('codigoTipoEndereco').valueChanges.pipe(
      startWith(''),
      map((value) => this._filterTipoEndereco(value || ''))
    );
  }


  private _filterPaises(value: string) {
    const filterValue = value?.length > 0 ? value?.toLowerCase() : '';
    return this.paises.filter((pais) =>
      pais?.Descricao?.toLowerCase()?.includes(filterValue)
    );
  }


  private _filterMunicipios(value: string) {
    const filterValue = value?.length > 0 ? value?.toLowerCase() : '';
    return this.municipios.filter((municipio) =>
      municipio?.Cidade?.toLowerCase()?.includes(filterValue)
    );
  }

  private _filterTipoEndereco(value: string) {
    const filterValue = value?.length > 0 ? value?.toLowerCase() : '';
    return this.tiposEndereco.filter((tipoEndereco) =>
      tipoEndereco?.Descricao?.toLowerCase()?.includes(filterValue)
    );
  }


  displayFn = (codigo: string): string => {
    const selected = this.paises.find(p => p.CodigoPais === codigo);
    return selected ? selected.Descricao : '';
  };

  displayFnMunicipio = (codigo: string): string => {
    const selected = this.municipios.find(p => p.CodigoMunicipio === codigo);
    return selected ? selected.Cidade : '';
  };

  displayFnTipoEndereco = (codigo: string): string => {
    const selected = this.tiposEndereco.find(p => p.CodigoTipoEndereco === codigo);
    return selected ? selected.Descricao : '';
  };

  async getPaises() {
    this.isLoading = true;
    this.getPaisesRepository
      .get()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.buildMatAutoCompletePaises();
        })
      )
      .subscribe((pais: any) => {
        pais.Data.forEach((pais: any) => {
          this.paises.push(pais);
        });
      });
  }

  async getMunicipios() {
    this.isLoading = true;
    this.getMunicipiosRepository
      .get()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.buildMatAutoCompleteMunicipios();
        })
      )
      .subscribe((municipioResponse: any) => {
        municipioResponse.Data.forEach((municipio: any) => {
          this.municipios.push(municipio);
        });
      });
  }



  async getTiposEndereco() {
    this.isLoading = true;
    this.getTiposEnderecoRepository
      .get()
      .pipe(
        finalize(() => {
          this.isLoading = false;
          this.buildMatAutoCompleteTipoEndereco();
        })
      )
      .subscribe((tipoEnderecoResponse: any) => {
        tipoEnderecoResponse.Data.forEach((tipoEndereco: any) => {
          this.tiposEndereco.push(tipoEndereco);
        });
      });
  }



  createFormGroup() {
    this.formReservas = this._formBuilder.group({
      cpf: new FormControl('', [Validators.required]),
      passaporte: new FormControl('', [
        Validators.required,
        Validators.pattern('^(?!^0+$)[a-zA-Z0-9]{7,9}$'),
      ]),
      rg: new FormControl('', [Validators.required]),
      driveLicenseNumber: new FormControl(''),
      dataNascimento: new FormControl('', [Validators.required]),
      nomeCompleto: new FormControl('', [Validators.required]),
      estrangeiro: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      telefone: new FormControl('', [Validators.required]),
      dadosVoo: new FormControl(''),
      driveLicenseDateExpire: new FormControl(''),
      driveLicenseCategory: new FormControl(''),
      reservationFiles: new FormControl(''),
      frontLicenseFile: new FormControl(''),
      backLicenseFile: new FormControl(''),
      //Campos endereço
      codigoTipoEndereco: new FormControl('', [Validators.required, this.createValidator(this.tiposEndereco, 'CodigoTipoEndereco')]),
      cep: new FormControl('', [Validators.required]),
      logradouro: new FormControl('', [Validators.required]),
      numero: new FormControl('', [Validators.required]),
      complemento: new FormControl(''),
      bairro: new FormControl('', [Validators.required]),
      codigoMunicipio: new FormControl('', [Validators.required, this.createValidator(this.municipios, 'CodigoMunicipio')]),
      codigoPais: new FormControl('', [Validators.required, Validators.required, this.createValidator(this.paises, 'CodigoPais')]),

    });
  }

  get telefoneControl(): FormControl {
    return this.formReservas.get('telefone') as FormControl;
  }
  
  async getClienteCPF(cpf: string) {
    this.cliente = {} as Cliente;
    this.controller
      .getByCpfOrPass(cpf, 'cpf')
      .pipe(finalize(() => { }))
      .subscribe({
        next: (cliente: any) => {
          if (cliente?.Data?.CodigoCliente) {
            this.codigoCliente = cliente.Data.CodigoCliente;
            this.novoClienteToggle(false);
            if (cliente.Data.Nome) {
              this.formReservas.patchValue({
                nomeCompleto: cliente.Data.Nome
              });
            }
            if (cliente.Data.DataNascimento) {
              const dataCorrigida = moment(cliente.Data.DataNascimento)
                .add(1, 'day') // Adiciona 1 dia
                .toDate();     // Converte para Date do JavaScript

              this.formReservas.patchValue({
                dataNascimento: dataCorrigida
              });

              this.dateSelected = dataCorrigida;
            }
            if (cliente.Data.Email) {
              this.formReservas.patchValue({
                email: cliente.Data.Email
              });
            }
            if (cliente.Data.Telefone) {
              this.formReservas.patchValue({
                telefone: cliente.Data.Telefone
              });
            }
            if (cliente.Data.Estrangeiro) {
              this.formReservas.patchValue({
                estrangeiro: cliente.Data.Estrangeiro
              });
            }
          } else {
            this.codigoCliente = null;
            this.novoClienteToggle(true);
            this.limparDadosCliente();
          }
        },
        error: () => {
          this.codigoCliente = null;
          this.novoClienteToggle(true);
          this.limparDadosCliente();
        }
      });
  }

  onDocumentChange(value: string) {
    this.isCPFFunction(
      value === 'cpf',
      value === 'passaporte',
      value === 'rg',
      value === 'drivelicense'
    );
  }

  onDocumentChangeOnLoad(value: string) {
    this.isCPFFunctionOnLoad(
      value === 'cpf',
      value === 'passaporte',
      value === 'rg',
      value === 'drivelicense'
    );
  }

  async getClienteCNH(numeroCNH: string) {
    this.cliente = {} as Cliente;
    this.controller
      .getByCpfOrPass(numeroCNH, 'numeroCNH')
      .pipe(finalize(() => { }))
      .subscribe({
        next: (cliente: any) => {
          if (cliente && cliente.Data && cliente.Data.CodigoCliente) {
            this.codigoCliente = cliente.Data.CodigoCliente;
            this.novoClienteToggle(false);
            if (cliente.Data.Nome) {
              this.formReservas.patchValue({
                nomeCompleto: cliente.Data.Nome
              });
            }
            if (cliente.Data.DataNascimento) {
              const dataCorrigida = moment(cliente.Data.DataNascimento)
                .add(1, 'day') // Adiciona 1 dia
                .toDate();     // Converte para Date do JavaScript

              this.formReservas.patchValue({
                dataNascimento: dataCorrigida
              });

              this.dateSelected = dataCorrigida;
            }
            if (cliente.Data.Email) {
              this.formReservas.patchValue({
                email: cliente.Data.Email
              });
            }
            if (cliente.Data.Telefone) {
              this.formReservas.patchValue({
                telefone: cliente.Data.Telefone
              });
            }
            if (cliente.Data.Estrangeiro) {
              this.formReservas.patchValue({
                estrangeiro: cliente.Data.Estrangeiro
              });
            }
          } else {
            this.codigoCliente = null;
            this.novoClienteToggle(true);
            this.limparDadosCliente();
          }
        },
        error: () => {
          this.codigoCliente = null;
          this.novoClienteToggle(true);
          this.limparDadosCliente();
        }
      });
  }

  async getClienteRG(rg: string) {
    this.cliente = {} as Cliente;
    this.controller
      .getByCpfOrPass(rg, 'rg')
      .pipe(finalize(() => { }))
      .subscribe({
        next: (cliente: any) => {
          if (cliente && cliente.Data && cliente.Data.CodigoCliente) {
            this.codigoCliente = cliente.Data.CodigoCliente;
            this.novoClienteToggle(false);
            if (cliente.Data.Nome) {
              this.formReservas.patchValue({
                nomeCompleto: cliente.Data.Nome
              });
            }
            if (cliente.Data.DataNascimento) {
              const dataCorrigida = moment(cliente.Data.DataNascimento)
                .add(1, 'day') // Adiciona 1 dia
                .toDate();     // Converte para Date do JavaScript

              this.formReservas.patchValue({
                dataNascimento: dataCorrigida
              });

              this.dateSelected = dataCorrigida;
            }
            if (cliente.Data.Email) {
              this.formReservas.patchValue({
                email: cliente.Data.Email
              });
            }
            if (cliente.Data.Telefone) {
              this.formReservas.patchValue({
                telefone: cliente.Data.Telefone
              });
            }
            if (cliente.Data.Estrangeiro) {
              this.formReservas.patchValue({
                estrangeiro: cliente.Data.Estrangeiro
              });
            }
          } else {
            this.codigoCliente = null;
            this.novoClienteToggle(true);
            this.limparDadosCliente();
          }
        },
        error: () => {
          this.codigoCliente = null;
          this.novoClienteToggle(true);
          this.limparDadosCliente();
        }
      });
  }

  async getClientePassaporte(pass: string) {
    this.cliente = {} as Cliente;
    this.controller
      .getByCpfOrPass(pass, 'passaporte')
      .pipe(
        finalize(() => { }))
      .subscribe({
        next: (cliente: any) => {
          if (cliente && cliente.Data && cliente.Data.CodigoCliente) {
            this.codigoCliente = cliente.Data.CodigoCliente;
            this.novoClienteToggle(false);
            if (cliente.Data.Nome) {
              this.formReservas.patchValue({
                nomeCompleto: cliente.Data.Nome
              });
            }
            if (cliente.Data.DataNascimento) {
              const dataCorrigida = moment(cliente.Data.DataNascimento)
                .add(1, 'day') // Adiciona 1 dia
                .toDate();     // Converte para Date do JavaScript

              this.formReservas.patchValue({
                dataNascimento: dataCorrigida
              });

              this.dateSelected = dataCorrigida;
            }
            if (cliente.Data.Email) {
              this.formReservas.patchValue({
                email: cliente.Data.Email
              });
            }
            if (cliente.Data.Telefone) {
              this.formReservas.patchValue({
                telefone: cliente.Data.Telefone
              });
            }
            if (cliente.Data.Estrangeiro) {
              this.formReservas.patchValue({
                estrangeiro: cliente.Data.Estrangeiro
              });
            }
          } else {
            this.codigoCliente = null;
            this.novoClienteToggle(true);
            this.limparDadosCliente();
          }
        },
        error: () => {
          this.codigoCliente = null;
          this.novoClienteToggle(true);
          this.limparDadosCliente();
        }
      });
  }

  async changePassaporte(event: any) {
    const value = event.target.value;
    await this.getClientePassaporte(value);
  }

  async changeRG(event: any) {
    const value = event.target.value;
    await this.getClienteRG(value);

  }

  async changeCNH(event: any) {
    const value = event.target.value;
    await this.getClienteCNH(value);
  }

  async changeCPF(event: any) {
    const value = event.target.value;
    await this.getClienteCPF(value);
  }

  isCPFFunction(isCpf: boolean, isPassaport: boolean, isItin: boolean, drivelicense: boolean
  ) {
    this.isItin = isItin;
    this.isPassaport = isPassaport;
    this.isCPF = isCpf;
    this.isDriveLicense = drivelicense;
    this.formReservas.reset();
    this.dateSelected = null;
  }

  isCPFFunctionOnLoad(isCpf: boolean, isPassaport: boolean, isItin: boolean, drivelicense: boolean
  ) {
    this.isItin = isItin;
    this.isPassaport = isPassaport;
    this.isCPF = isCpf;
    this.isDriveLicense = drivelicense;
  }


  setFirstDate(data: any) {
    if (data?.targetElement?.value && data?.targetElement?.value?.length > 9)
      this.formReservas.patchValue({ dataNascimento: data?.targetElement?.value });
    else if (data?.target?.value && data?.target?.value?.length > 9)
      this.formReservas.patchValue({ dataNascimento: data?.target?.value });
  }

  setDriveLicenseDate(data: any) {
    if (data?.targetElement?.value && data?.targetElement?.value?.length > 9)
      this.formReservas.patchValue({ driveLicenseDateExpire: data?.targetElement?.value });
    else if (data?.target?.value && data?.target?.value?.length > 9)
      this.formReservas.patchValue({ driveLicenseDateExpire: data?.target?.value });
  }

  validateFields() {
    this.formReservas.markAllAsTouched();
    if (this.isCPF && !(this.habilitarRedirecionamentoIMOB && this.desobrigarIdentificadorPessoa)) {
      if (!this.formReservas.controls['cpf'].value) {
        this.notification.showSnack(
          this.translateService.instant('MSG_INSERT_VALID_CPF'),
          NotificationStyle.ERROR
        );
        return false;
      }
    }
    if (this.isPassaport) {
      if (!this.formReservas.controls['passaporte'].value) {
        this.notification.showSnack(
          this.translateService.instant('MSG_INSERT_VALID_PASSPORT'),
          NotificationStyle.ERROR
        );
        return false;
      }
    }
    if (this.isItin) {
      if (!this.formReservas.controls['rg'].value) {
        this.notification.showSnack(
          this.translateService.instant('MSG_INSERT_VALID_RG'),
          NotificationStyle.ERROR
        );
        return false;
      }
    }
    if (!this.formReservas.controls['dataNascimento'].value) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_VALID_BIRTH_DATE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.formReservas.controls['nomeCompleto'].value) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_FULL_NAME'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.formReservas.controls['estrangeiro'].value) {
      this.notification.showSnack(
        this.translateService.instant('MSG_DEFINE_NATIONALITY'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.formReservas.controls['email'].value) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_VALID_EMAIL'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.formReservas.controls['telefone'].value) {
      this.notification.showSnack(
        this.translateService.instant('MSG_INSERT_VALID_PHONE'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.formReservas.controls['frontLicenseFile'].value && this.isDriveLicense) {
      this.notification.showSnack(
        this.translateService.instant('MSG_DRIVE_LICENSE_PHOTO'),
        NotificationStyle.ERROR
      );
      return false;
    }
    if (!this.acceptedTerms) {
      this.acceptedTerms = false;
      this.notification.showSnack(
        this.translateService.instant('MSG_ACCEPT_TERMS'),
        NotificationStyle.ERROR
      );
      return false;
    }

    if (this.novoCliente) {
      if (
        !this.formReservas.controls['cep'].value ||
        !this.formReservas.controls['logradouro'].value ||
        !this.formReservas.controls['numero'].value ||
        !this.formReservas.controls['bairro'].value ||
        !this.formReservas.controls['codigoTipoEndereco'].value ||
        !this.formReservas.controls['codigoMunicipio'].value ||
        !this.formReservas.controls['codigoPais'].value ||
        this.formReservas.controls['codigoTipoEndereco'].invalid ||
        this.formReservas.controls['codigoMunicipio'].invalid ||
        this.formReservas.controls['codigoPais'].invalid
      ) {
        this.notification.showSnack(
          this.translateService.instant('MSG_INSERT_VALID_ADDRESS'),
          NotificationStyle.ERROR
        );
        return false;
      }
    }

    return true;
  }

  async submitForm() {
    try {
      if (!this.validateFields()) return;

      if (!this.novoCliente) {
        // Se não é novo cliente, envia direto a reserva
        await this.postReservas();
        return;
      }

      const clienteCriado = await this.createCliente();
      if (!clienteCriado) {
        return; // Interrompe o envio se cliente não foi criado
      }

      await this.postReservas();

    } catch (error) {
      console.error('Erro ao criar cliente ou enviar reserva:', error);
    }
  }

  async postReservas() {
    this.isLoading = true;
    await this.createFormGroupPost();
    let data = this.formReservasPost.value    
    const extraHoursData = JSON.parse(sessionStorage.getItem('extraHours') || '{}');
    data = Object.entries(data).reduce((a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a), {});
    data = {
      ...data,
      CodigoCliente: this.codigoCliente,
      ValorHoraExtra: (this.reservaService?.tariffData?.ValorHoraExcedente ?? extraHoursData?.valorHoraExtra ?? 0),
      Condutores: [  // Garante que é array
        {
          CodigoReservaCondutor: null,
          CodigoReserva: null,
          CondutorCadastrado: 'N',
          CodigoCondutor: this.formReservas.controls['codigoCondutor']?.value,
          Nome: this.formReservas.controls['nomeCompleto']?.value,
          CPF: this.formReservas.controls['cpf']?.value,
          NumeroCNH: this.formReservas.controls['driveLicenseNumber']?.value,
          CategoriaCNH: this.formReservas.controls['driveLicenseCategory']?.value,
          ValidadeCNH: this.formReservas.controls['driveLicenseDateExpire']?.value,
          DataPrimeiraHabilitacao: null,
          CondutorPrincipal: 'N'
        }
      ]
    };
    if (data) {
      this.controllerReserva.insert(data).subscribe({
        error: (err: any) => {
          this.isLoading = false;
          this.notification.showError(err[0]);
        },
        next: (value: any) => {
          this.isLoading = false;
          this.notification.showSnack(
            this.translateService.instant('TXT_DONE_RESERVATION'),
            NotificationStyle.SUCCESS
          );
          if (this.habilitarRedirecionamentoIMOB && value?.Data?.LinkIturanMob) {
            sessionStorage.setItem('linkImob', value?.Data?.LinkIturanMob)
          }
          this.reservaService.clear();
          this.isLoading = false;

          this.router.navigateByUrl(AppPages.SUCCESS, {
            state: { CodigoReserva: value.Data.CodigoReserva },
          });
        },
      });
    }
  }

  formatTo24Hour(hourString: string): string {
    if (!hourString) return '';
    return hourString; // Mantém o formato original de 24 horas
  }

  format12To24Hour(hourString: string): string {
    const trimmedHourString = hourString.trim().toUpperCase();

    const [timePart, period] = trimmedHourString.split(/\s+/); // Divide "hh:mm AM"
    const [hourPart, minutePart] = timePart.split(':').map(Number);

    let hour24 = hourPart;

    if (period === 'AM') {
      if (hourPart === 12) {
        hour24 = 0;
      }
    } else if (period === 'PM') {
      if (hourPart !== 12) {
        hour24 += 12;
      }
    }

    return `${hour24.toString().padStart(2, '0')}:${minutePart.toString().padStart(2, '0')}`;
  }

  async createFormGroupPost() {
    const valorTotalLocacao = sessionStorage.getItem('totalPrice')
    const valorTotalLocacaoComDesconto = sessionStorage.getItem('totalPriceDiscount')
    const currency = localStorage.getItem('language')

    // Ajusta as datas para o formato correto
    const adjustDateFormat = (date: string) => {
      if (environment.defaultDateInput === 'MM/DD/YYYY') {
        const [month, day, year] = date.split('/');
        return `${day}/${month}/${year}`; // Converte para DD/MM/YYYY
      }
      return date; // Mantém DD/MM/YYYY
    };

    this.formReservasPost = this._formBuilder.group({
      CodigoEmpresa: new FormControl(this.reservaService.reservasData.CodigoEmpresa, [
        Validators.required,
      ]),
      CodigoUnidade: new FormControl(this.reservaService.reservasData.CodigoUnidade, [
        Validators.required,
      ]),
      CodigoEmpresaDevolucao: new FormControl(
        this.reservaService.reservasData.CodigoEmpresaDevolucao,
        [Validators.required]
      ),
      CodigoUnidadeDevolucao: new FormControl(
        this.reservaService.reservasData.CodigoUnidadeDevolucao,
        [Validators.required]
      ),
      CodigoGrupo: new FormControl(this.reservaService.reservasData.CodigoGrupo, [
        Validators.required,
      ]),
      CodigoProtecao: new FormControl(this.reservaService?.protectionData?.CodigoProtecao, [
        Validators.required,
      ]),
      CodigoTarifa: new FormControl(this.reservaService?.tariffData?.CodigoTarifaVeiculo, [
        Validators.required,
      ]),
      ValorTarifa: new FormControl((this.reservaService?.tariffData.ValorPeriodoVeiculo - this.reservaService?.tariffData?.ValorDesconto), [
        Validators.required,
      ]),
      FranquiaKmRodado: new FormControl(this.reservaService?.tariffData.FranquiaKmRodado),
      DataInicio: new FormControl(
        adjustDateFormat(this.reservaService.reservasData.DataInicio), // Formata a data
        [Validators.required]
      ),
      DataTermino: new FormControl(
        adjustDateFormat(this.reservaService.reservasData.DataTermino), // Formata a data
        [Validators.required]
      ),
      HoraInicio: new FormControl(this.format12To24Hour(this.reservaService.reservasData.HoraInicio), [
        Validators.required,
      ]),
      HoraTermino: new FormControl(this.format12To24Hour(this.reservaService.reservasData.HoraTermino), [
        Validators.required,
      ]),
      CodigoMunicipioRetirada: new FormControl(
        this.reservaService.reservasData.CodigoMunicipioRetirada,
        [Validators.required]
      ),
      CodigoMunicipioDevolucao: new FormControl(
        this.reservaService.reservasData.CodigoMunicipioDevolucao,
        [Validators.required]
      ),
      Origem: new FormControl('W', [Validators.required]),
      ValorLocacaoJovem: new FormControl(
        this.reservaService.reservasData.ValorLocacaoJovem
          ? this.reservaService.reservasData.ValorLocacaoJovem
          : 0,
        [Validators.required]
      ),
      PercentualDescontoTarifa: new FormControl(
        this.reservaService.cupomData?.Percentual
          ? this.reservaService.cupomData.Percentual
          : 0,
        [Validators.required]
      ),
      ValorDescontoTarifa: new FormControl(
        this.reservaService.cupomData?.Percentual ? (this.reservaService.cupomData?.Percentual / 100) * this.reservaService?.tariffData?.ValorPeriodoVeiculo : 0,
        [Validators.required]
      ),
      CodigoCupomDesconto: new FormControl(
        this?.reservaService?.cupomData?.CodigoReservaCupomDesconto
          ? this.reservaService.cupomData.CodigoReservaCupomDesconto
          : null,
        [Validators.required]
      ),
      Adicionais: new FormControl(this.createAdditionalsArray(), [Validators.required]),
      Cliente: {
        CPF: this.formReservas.controls['cpf']?.value,
        RazaoSocial: this.formReservas.controls['nomeCompleto']?.value,
        RG: this.formReservas.controls['rg']?.value,
        Telefone: this.formReservas.controls['telefone']?.value,
        Email: this.formReservas.controls['email']?.value,
        Observacoes: this.formReservas.controls['dadosVoo']?.value,
        Passaporte: this.formReservas.controls['passaporte']?.value,
        // Enderecos: [{
        //   CodigoTipoEndereco: this.formReservas.controls['codigoTipoEndereco'].value,
        //   Cep: this.formReservas.controls['cep'].value
        // }]
      },
      ValorTotalLocacaoSemDesconto: +valorTotalLocacao,
      ValorTotalLocacaoComDesconto: +valorTotalLocacaoComDesconto,
      // PercentualDescontoTotalLocacao: this.reservaService.cupomData?.Percentual ? this.reservaService.cupomData.Percentual : 0,
      // ValorDescontoTotalLocacao: (this.reservaService.cupomData?.Percentual / 100) * +valorTotalLocacao,
      Currency: currency == 'pt-BR' ? 'BRL' : 'USD',
      AnexosReserva: this.formReservas.controls['reservationFiles']?.value,
      GerarCondutor: [this.isDriveLicense ? 'S' : 'N']
    });
  }

  private formatDate(date: string): string {
    // Converte a data do formato DD/MM/YYYY para MM-DD-YYYY
    const [day, month, year] = date.split('/');
    if (this.currentLanguage != 'en-US') {
      return `${month}-${day}-${year}`;
    } else {
      return `${day}-${month}-${year}`;
    }
  }

  createAdditionalsArray() {
    let servicosAdicionais = []
    if (this.reservaService?.additionalsData && this.reservaService?.additionalsData.length > 0) {
      servicosAdicionais = this.reservaService?.additionalsData?.map(
        (servico: ServicoAdicional) => {
          const ServicoAdicional = {
            Id: servico.CodigoServicoAdicional,
            Quantidade: servico.Quantidade,
          };
          return ServicoAdicional.Quantidade > 0 ? ServicoAdicional : null;
        }
      );
    }  
    let taxas = []  
    if (this.reservaService?.taxasData && this.reservaService?.taxasData.length > 0) {
      taxas = this.reservaService?.taxasData?.map(
        (taxa: Taxa) => {
          const Taxa = {
            Id: taxa.CodigoServicoAdicional,
            Quantidade: null,
            Percentual: taxa.PercentualTaxa,
            Tipo: taxa.Tipo
          }
          return Taxa.Id > 0 ? Taxa : null;
        }
      )
    }    
    for (let taxa of taxas) {
      servicosAdicionais.push(taxa)
    }

    return servicosAdicionais?.filter(Boolean);
  }

  openTermsDialog() {
    const dialogRef = this.dialog.open(DialogTermsComponent, {
      width: "900px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      data: this.reservaService.reservasData.CodigoEmpresa,
    });
    dialogRef
      .afterClosed()
      .subscribe((result) => (result ? (this.acceptedTerms = true) : (this.acceptedTerms = false)));
  }

  acceptTerms(accepted: boolean) {
    this.acceptedTerms = accepted;
    this.openTermsDialog();
  }

  async nextPage(): Promise<boolean> {
    if (!this.validateFields()) return false;

    // Se NÃO é novo cliente, pula o try/catch e faz o post direto
    if (!this.novoCliente) {
      sessionStorage.setItem('personData', JSON.stringify(this.formReservas.value));

      if (this.isDriveLicense) {
        this.prepareFilePayload();
      }
      await this.createFormGroupPost();

      let data = this.formReservasPost.value;
      const extraHoursData = JSON.parse(sessionStorage.getItem('extraHours') || '{}');
      data = Object.entries(data).reduce((a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a), {});
      data = {
        ...data,
        CodigoCliente: this.codigoCliente,
        ValorHoraExtra: (this.reservaService?.tariffData?.ValorHoraExcedente ?? extraHoursData?.valorHoraExtra ?? 0),
        Condutores: [  // Garante que é array
          {
            CodigoReservaCondutor: null,
            CodigoReserva: null,
            CondutorCadastrado: 'N',
            CodigoCondutor: this.formReservas.controls['codigoCondutor']?.value,
            Nome: this.formReservas.controls['nomeCompleto']?.value,
            CPF: this.formReservas.controls['cpf']?.value,
            NumeroCNH: this.formReservas.controls['driveLicenseNumber']?.value,
            CategoriaCNH: this.formReservas.controls['driveLicenseCategory']?.value,
            ValidadeCNH: this.formReservas.controls['driveLicenseDateExpire']?.value,
            DataPrimeiraHabilitacao: null,
            CondutorPrincipal: 'N'
          }
        ]
      };

      sessionStorage.setItem('reservaPostPayload', JSON.stringify(data));
      return true;

    }

    // Caso seja novo cliente, segue o fluxo normal com try/catch
    try {
      const clienteCriado = await this.createCliente();
      if (!clienteCriado) {
        return false; // interrompe o fluxo se não criar cliente
      }

      sessionStorage.setItem('personData', JSON.stringify(this.formReservas.value));

      if (this.isDriveLicense) {
        this.prepareFilePayload();
      }
      await this.createFormGroupPost();

      let data = this.formReservasPost.value;
      const extraHoursData = JSON.parse(sessionStorage.getItem('extraHours') || '{}');
      data = Object.entries(data).reduce((a: any, [k, v]: any) => (v ? ((a[k] = v), a) : a), {});
      data = {
        ...data,
        CodigoCliente: this.codigoCliente,
        ValorHoraExtra: (this.reservaService?.tariffData?.ValorHoraExcedente ?? extraHoursData?.valorHoraExtra ?? 0),
        Condutores: [  // Garante que é array
          {
            CodigoReservaCondutor: null,
            CodigoReserva: null,
            CondutorCadastrado: 'N',
            CodigoCondutor: this.formReservas.controls['codigoCondutor']?.value,
            Nome: this.formReservas.controls['nomeCompleto']?.value,
            CPF: this.formReservas.controls['cpf']?.value,
            NumeroCNH: this.formReservas.controls['driveLicenseNumber']?.value,
            CategoriaCNH: this.formReservas.controls['driveLicenseCategory']?.value,
            ValidadeCNH: this.formReservas.controls['driveLicenseDateExpire']?.value,
            DataPrimeiraHabilitacao: null,
            CondutorPrincipal: 'N'
          }
        ]
      };

      sessionStorage.setItem('reservaPostPayload', JSON.stringify(data));
      return true;

    } catch (e) {
      console.error('Erro ao processar nextPage:', e);
      return false;
    }
  }


  async backPage() {
    this.router.navigateByUrl(AppPages.ADDITIONALS);
  }

  get isStepValid(): boolean {
    return this.isLoading;
  }

  prepareFilePayload() {
    const frontLicenseFile = this.formReservas.get('frontLicenseFile')?.value;
    const backLicenseFile = this.formReservas.get('backLicenseFile')?.value;

    if (frontLicenseFile?.Arquivos[0] && backLicenseFile?.Arquivos[0]) {
      this.formReservas.get('reservationFiles')?.setValue({
        Entidade: 'Reservas',
        Chave: null,
        Arquivos: [
          frontLicenseFile?.Arquivos[0],
          backLicenseFile?.Arquivos[0]
        ]
      })
    } else if (frontLicenseFile?.Arquivos[0] && !backLicenseFile?.Arquivos[0]) {
      this.formReservas.get('reservationFiles')?.setValue({
        Entidade: 'Reservas',
        Chave: null,
        Arquivos: [
          frontLicenseFile.Arquivos[0]
        ]
      })
    }
  }



  onImageChanged(file: File | null, imageField: string): void {
    if (file) {
      // Usando o Compressor.js para comprimir a imagem
      new Compressor(file, {
        quality: 0.4,  // Define a qualidade da imagem comprimida (0 a 1, sendo 1 sem compressão)
        maxWidth: 800,  // Limite de largura
        maxHeight: 800,  // Limite de altura
        success: (compressedFile: any) => {

          // Cria um FileReader para ler a imagem comprimida como Base64
          const reader = new FileReader();
          reader.readAsDataURL(compressedFile);

          reader.onload = () => {
            const base64 = (reader.result as string).split(',')[1];

            // Cria o objeto 'arquivo' com as informações da imagem
            const arquivo = {
              CodigoAnexo: null,
              filename: compressedFile.name,
              content: base64,
              encoding: 'base64',
              type: compressedFile.type,
            };

            // Cria o payload para enviar ao backend
            const payload = {
              imageView: reader.result,  // A imagem no formato DataURL
              Entidade: 'Reservas',
              Chave: null,
              Arquivos: [arquivo]
            };

            // Define os valores nos campos do formulário
            this.formReservas.get(imageField)?.setValue(payload);

            // Força a detecção de mudanças para atualizar imediatamente o estado do formulário, sem ele, ao inserir o último anexo o botão de próximo não é habilitado imediatamente, apenas quando é clicado novamente.
            this.cdr.detectChanges();
          };

          reader.onerror = (error) => {
            console.log('Erro ao ler a imagem comprimida:', error);
          };
        },
        error: (err) => {
          console.log('Erro ao comprimir a imagem:', err);
        }
      });
    } else {
      // Caso o arquivo seja null, limpa os campos
      this.formReservas.get(imageField)?.setValue(null);

    }
  }


  public createCliente(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.novoCliente) {
        const clientePayload = {
          Pessoa: {
            RazaoSocial: this.formReservas.get('nomeCompleto').value,
            NomeFantasia: this.formReservas.get('nomeCompleto').value,
            TipoPessoa: "F",
            Estrangeiro: this.formReservas.get('estrangeiro').value,
            Passaporte: this.formReservas.get('passaporte').value,
            CPF: this.formReservas.get('cpf').value,
            CNPJ: null,
            Telefone: this.formReservas.get('telefone').value,
            Email: this.formReservas.get('email').value,
            Enderecos: [
              {
                CodigoTipoEndereco: this.formReservas.get('codigoTipoEndereco').value,
                Cep: this.formReservas.get('cep').value,
                Logradouro: this.formReservas.get('logradouro').value,
                Numero: this.formReservas.get('numero').value,
                Complemento: this.formReservas.get('complemento').value,
                Bairro: this.formReservas.get('bairro').value,
                CodigoMunicipio: this.formReservas.get('codigoMunicipio').value,
                CodigoPais: this.formReservas.get('codigoPais').value,
                Principal: "S",
                Latitude: null,
                Longitude: null
              }
            ]
          }
        };

        this.controller.insert(clientePayload).subscribe({
          next: (value: any) => {
            this.codigoCliente = value?.Data?.CodigoCliente;
            resolve(true);

          },
          error: (err) => {
            const message =
              err?.error?.Data?.[0]?.message ||
              err?.error?.Message ||
              err?.message

            Swal.fire({
              icon: 'error',
              title: this.translateService.instant('TXT_CLIENT_ERROR'),
              text: message
            });

            reject(false);
          }
        });

      } else {
        reject(false);
      }
    }
    )
  }

  limparDadosCliente() {
    this.formReservas.patchValue({
      nomeCompleto: '',
      dataNascimento: '',
      email: '',
      telefone: '',
      estrangeiro: ''
    });
    this.dateSelected = null;
  }

  novoClienteToggle(novoCliente) {
    if (novoCliente == true) {
      this.codigoCliente = null
      this.formReservas.get('codigoTipoEndereco').setValue('')
      this.formReservas.get('cep').setValue('')
      this.formReservas.get('logradouro').setValue('')
      this.formReservas.get('numero').setValue('')
      this.formReservas.get('complemento').setValue('')
      this.formReservas.get('bairro').setValue('')
      this.formReservas.get('codigoMunicipio').setValue('')
      this.formReservas.get('codigoPais').setValue('')

    }
    this.exibirAgrupamentoEndereco = novoCliente
    this.novoCliente = novoCliente
  }

  getMascaraCep() {
    const padraoNacional = '00000-000'
    const padraoMascaraCep = sessionStorage.getItem('padraoMascaraCep')
    if (padraoMascaraCep)
      return padraoMascaraCep
    else
      return padraoNacional
  }

  createValidator(list: any[], key: string) {
    return (control: AbstractControl) => {
      const value = control.value;
      const isValid = list.some(item => item[key] === value);
      return isValid ? null : { invalidSelection: true };
    };
  }

  // Blur handler para limpar valores inválidos
  onBlur(formControlName: string, list: any[], key: string) {
    const control = this.formReservas.get(formControlName);
    const value = control?.value;
    const isValid = list.some(item => item[key] === value);
    if (!isValid) {
      control?.setValue(null);
      control?.markAsTouched();
    }
  }
}
